<template>
  <div style="height: 100%; width: 100%">
    <TMapMarker :markers="markers" :zoom="zoom" />
  </div>
</template>

<script>
import TMapMarker from "./TMapMarkerNew.vue";
export default {
  props: {
    zoom: {
      type: Number,
      default: 5,
    },
  },
  components: {
    TMapMarker,
  },
  data() {
    return {
      markers: [
        {
          lat: 39.916527,
          lng: 116.397128,
          title: "天安门",
        },
        {
          lat: 39.908722,
          lng: 116.397499,
          title: "故宫",
        },
      ],
    };
  },
  created() {
    this.getPoint();
  },
  methods: {
    onMapReady() {
      console.log("地图已准备好");
    },
    handleMarkerClick(marker) {
      console.log("点击了标记:", marker.title);
    },
    getPoint() {
      // this.loading=true
      this.$api.home.getPoint().then((response) => {
        if (response.code == 200) {
          let markers = [];
          response.data.forEach((ele, index) => {
            markers.push({
              lat: ele.latitude,
              lng: ele.longitude,
              title: ele.projectGroupName,
            });
          });
          this.markers = markers;
        }
      });
    },
  },
};
</script>
